import { createShuttersPolygon, getEasing } from '../../utils';
export default function create(options) {
  const {
    direction = 'right',
    shutters = 12,
    staggered = true
  } = options.namedEffect;
  const easing = getEasing(options.easing || 'sineIn');
  const {
    clipStart,
    clipEnd
  } = createShuttersPolygon(direction, shutters, staggered);
  return [{
    ...options,
    easing,
    keyframes: [{
      clipPath: clipStart
    }, {
      clipPath: clipEnd
    }]
  }];
}
//# sourceMappingURL=ShuttersIn.js.map